import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router";
import { Navigate, Outlet } from "react-router-dom";

import { clearErrorUser } from "../redux/slices/userSlice";

const UnauthenticatedRoute = ({ user }) => {
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(clearErrorUser());
  }, [dispatch, location.pathname]);

  if (user) {
    if (user.is_first_login) {
      return <Navigate to="/password-change" replace state={{ from: location }} />;
    }

    if (user.is_admin) {
      return <Navigate to="/collaborators" replace state={{ from: location }} />;
    }

    return <Navigate to="/collaborator" replace state={{ from: location }} />;
  }

  return <Outlet />;
};

export default UnauthenticatedRoute;
